import React, { useCallback, useEffect, useState } from 'react';
import { History } from 'history';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { PageKey } from 'enums';

import { PortfolioItem } from './portfolio-items-hook';
import { PortfolioClasses } from './portfolio-styles';

interface PortfolioListItemProps extends PortfolioItem {
  selected: PageKey;
  breadcrumbKey: PageKey;
  classes: PortfolioClasses;
  history: History;
  level?: number;
  subItems?: PortfolioItem[];
}

export function PortfolioListItem({
  selected,
  breadcrumbKey,
  classes,
  history,
  label,
  path,
  level = 1,
  subItems = [],
}: PortfolioListItemProps & { history: History }) {
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    if (!!path) {
      history.push(path);
    } else {
      setOpen((o) => !o);
    }
  }, [history, path]);

  const withSubItems = subItems.length > 0;
  const breadcrumbKeys = [breadcrumbKey, ...subItems.map(({ key }) => key)];
  const isSelected = breadcrumbKeys.some((b) => b === selected);

  useEffect(() => {
    setOpen(isSelected);
  }, [isSelected]);

  return (
    <>
      <ListItem
        button
        onClick={handleClick}
        selected={isSelected}
        classes={{
          selected: classes.itemActive,
        }}
        className={classes.item}
        style={{ paddingLeft: 15 * level }}
      >
        <ListItemText primary={label} classes={{ primary: classes.itemText }} />
        {withSubItems && (open ? <ExpandLess /> : <ExpandMore />)}
      </ListItem>
      {withSubItems && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="nav" dense={true}>
            {subItems.map((item) => (
              <PortfolioListItem
                selected={selected}
                breadcrumbKey={item.key}
                classes={classes}
                history={history}
                level={level + 1}
                {...item}
              />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
}
